/* eslint-disable eqeqeq */
/* eslint-disable prefer-const */
import {
  CheckoutFormErrorLabelsType,
  CheckoutFormErrorsResultType,
  AddressDTO,
} from '@sentecacommerce-theme/lib'
const requiredCompanyFields = [
  'vatId',
  'companyId',
  'companyPerson',
  'companyName',
]
const requiredFields = ['additionalAddressInfo']
export type BillingAddressValidationType = (
  data: AddressDTO,
  errorLabels: CheckoutFormErrorLabelsType
) => CheckoutFormErrorsResultType
export function customBillingAddressValidation(
  data: AddressDTO,
  errorLabels: CheckoutFormErrorLabelsType
): CheckoutFormErrorsResultType {
  const isWithInvoice = Boolean(data.company)
  if (!isWithInvoice) return null
  const companyErrors = requiredCompanyFields.reduce((errors, field) => {
    if (!data?.company?.[field]?.trim()) {
      return { ...errors, [field]: errorLabels.fieldIsRequired }
    }
    return errors
  }, {})
  const fieldErrors = requiredFields.reduce((errors, field) => {
    if (!data[field]?.trim()) {
      return { ...errors, [field]: errorLabels.fieldIsRequired }
    }
    return errors
  }, {})
  const errors = {
    ...companyErrors,
    ...fieldErrors,
  }
  return Object.keys(errors).length ? errors : null
}